<template>
    <div class="mr-4" v-can="'view-customer-support'">
        <vs-button @click="onClickSupportApp" icon-pack="feather" icon="icon-external-link" color="success"
            type="border">Support App</vs-button>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const StaffRepository = RepositoryFactory.get('staff')
import { SUPPORT_APP_URL } from "@/constants/config";

export default {
    name: "SupportAppButton",
    data() {
        return {
            SUPPORT_APP_URL: SUPPORT_APP_URL
        }
    },
    methods: {
        async onClickSupportApp() {
            try {
                const { data } = (await StaffRepository.fetchSupportAppToken()).data
                window.open(`${SUPPORT_APP_URL}/auth?code=${data.sso_token}&type=Nimble`, '_blank');
            } catch (error) {

            }
        }
    }
}
</script>
<style lang="">

</style>